/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DocumentResponseDTO } from './DocumentResponseDTO';

export type BusinessDetailsResponseDTO = {
    businessDescription?: string;
    businessName?: string;
    businessSector?: string;
    businessTradingName?: string;
    businessType?: string;
    documents?: Array<DocumentResponseDTO>;
    verificationStatus?: BusinessDetailsResponseDTO.verificationStatus;
};

export namespace BusinessDetailsResponseDTO {

    export enum verificationStatus {
        PENDING = 'PENDING',
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
    }


}

